const eventer = require('./eventer');
const api     = eventer({});

let onLine = navigator.onLine;

Object.defineProperty(api, 'onLine', {
  get() { return onLine; },
  set(val) {
    onLine = !!val;
    api.trigger(onLine ? 'online' : 'offline');
  }
});

module.exports = api;
